
export enum ClientScenario {
  Unresponsive = 'UNRESPONSIVE',
  WipAlertsAndChargeback = 'WIP_ALERTS_AND_CHARGEBACK',
  WipChargebackOnly = 'WIP_CHARGEBACK_ONLY',
  NoAccess = 'NO_ACCESS',
}

export const ScenarioCopy: Record<ClientScenario, {title: string; body: string}> = {
  [ClientScenario.Unresponsive]: {
    title: 'Action Needed',
    body: `Fraud Deflect requires additional details to display accurate alert and chargeback data on your dashboard and tables.<br>
Please contact <a>clientexperience@frauddeflect.com</a> to provide your API keys or explore how we can enable data access.`,
  },
  [ClientScenario.WipAlertsAndChargeback]: {
    title: 'Work In Progress (Alerts and Chargebacks)',
    body: `Chargeback and alert data may be incomplete or inaccurate because required data is missing.<br>
If you’d like, reach out to <a>clientexperience@frauddeflect.com</a> to discuss how we can improve accuracy.`,
  },
  [ClientScenario.WipChargebackOnly]: {
    title: 'Work In Progress (Chargebacks Only)',
    body: `Chargeback data may be incomplete or inaccurate because required data is missing.<br>
If you’d like, reach out to <a>clientexperience@frauddeflect.com</a>  to discuss how we can improve accuracy.`,
  },
  [ClientScenario.NoAccess]: {
    title: 'Data Unavailable (Access Not Granted)',
    body: `Chargeback and alert data is unavailable because permission to access MID information has not been granted.<br>
If you desire Fraud Deflect to populate this data, please contact <a>clientexperience@frauddeflect.com</a>`,
  },
};


export const CLIENT_SCENARIOS: Record<number, ClientScenario> = {
  // Unresponsive clients
  10038: ClientScenario.Unresponsive,    // Clario.io
  10374: ClientScenario.Unresponsive,    // KR Digital
  10393: ClientScenario.Unresponsive,    // Next Step Careers
  10009: ClientScenario.Unresponsive,    // Automatic Viral
  10035: ClientScenario.Unresponsive,    // CELL BROKERAGE LLC (Grip)
  10098: ClientScenario.Unresponsive,    // First Round Capital

  // “Work in Progress” - alerts + chargebacks
  10446: ClientScenario.WipAlertsAndChargeback, // ARCS Self Defense and Combatives LLC
  10069: ClientScenario.WipAlertsAndChargeback, // CaliberSmart (Signal Relief)
  10481: ClientScenario.WipAlertsAndChargeback, // CF Capital
  10309: ClientScenario.WipAlertsAndChargeback, // DITRONICS / GameTimeWallet

  // “Work in Progress” - chargebacks only
  3100:  ClientScenario.WipChargebackOnly, // Activate Software / Dugan
  10397: ClientScenario.WipChargebackOnly, // AI Profit University LLC
  10482: ClientScenario.WipChargebackOnly, // Astromedia LLC
  10405: ClientScenario.WipChargebackOnly, // Diesel LLC / Diesel Dispensary
  10033: ClientScenario.WipChargebackOnly, // Docubiz
  10462: ClientScenario.WipChargebackOnly, // Endless Getaways LLC
  10053: ClientScenario.WipChargebackOnly, // Explodely
  1001:  ClientScenario.WipChargebackOnly, // Goldaxa
  10259: ClientScenario.WipChargebackOnly, // Healthy Home
  10311: ClientScenario.WipChargebackOnly, // Infiniteage
  10303: ClientScenario.WipChargebackOnly, // Kennedy Pain Clinic Group
  10306: ClientScenario.WipChargebackOnly, // NP Solutions LLC
  10235: ClientScenario.WipChargebackOnly, // Peoples Group
  10061: ClientScenario.WipChargebackOnly, // Protrans Media
  10491: ClientScenario.WipChargebackOnly, // RF BEAUTY LABS LLC
  10301: ClientScenario.WipChargebackOnly, // River Systems LLC
  10258: ClientScenario.WipChargebackOnly, // Soul Mind Body
  10444: ClientScenario.WipChargebackOnly, // Soulmate Medium LLC
  10483: ClientScenario.WipChargebackOnly, // Summit Marketing Group LLC
  10218: ClientScenario.WipChargebackOnly, // Svelte Media Inc
  10514: ClientScenario.WipChargebackOnly, // VB Innovations
  10237: ClientScenario.WipChargebackOnly, // Vital Health International LLC

  // Clients that don’t provide access
  10005: ClientScenario.NoAccess, // Aviation Interviews LLC
  10173: ClientScenario.NoAccess, // Coin Flow Labs
  10503: ClientScenario.NoAccess, // Creditt (unicopay)
  10400: ClientScenario.NoAccess, // Reach Mobile
  10240: ClientScenario.NoAccess, // Starluck Flowers
};
